import { useState } from "react";
import { useLogin } from "../../hooks/useLogin";
import "./style.css"

function Login() {
    const postLogin = useLogin();
    const [form, setForm] = useState({ email: '', password: '' });
    const [save, setSave] = useState(localStorage.getItem('save_login') === 'true');

    const handleValue = (field, e) => {
        setForm({
            ...form,
            [field]: e.target.value
        });
    }

    const login = async (e) => {
        e.preventDefault();
        await postLogin(form.email, form.password, save);
    }

    return (
        <form className="form_login" onSubmit={login}>
            <h1>Se connecter</h1>

            <div className="blocks">
                <div className="inp_block">
                    <label>email</label>
                    <input
                        type="text"
                        value={form.email}
                        onChange={(e) => handleValue('email', e)}
                    />
                </div>

                <div className="inp_block">
                    <label>password</label>
                    <input
                        type="password"
                        value={form.password}
                        onChange={(e) => handleValue('password', e)}
                    />
                </div>
            </div>

            <div className="options">
                <button
                    type="button"
                    className="save_login"
                    onClick={() => setSave(!save)}
                >
                    <i>{save ? '✔' : ''}</i>
                    Se souvenir de moi
                </button>

                <button
                    disabled
                    type="button"
                    className="forget_pw"
                >Mot de passe oublié ?</button>
            </div>

            <button
                type="submit"
                className="btn_submit"
            >Se connecter</button>
        </form>
    )
}

export default Login;